import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EmEditIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EmEditIcon = ({ className, ...props }: EmEditIconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="22"
    viewBox="0 0 22 22"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_262_36127)">
      <path
        d="M21.2904 20.4188L20.2282 17.5846L19.4977 15.6338C19.3327 15.1302 19.3018 14.9222 19.0216 14.6421L16.9901 12.6105L12.6141 16.9864L14.6474 19.0197C14.8141 19.1864 15.1338 19.3291 15.6374 19.4941L17.5882 20.2246L20.4224 21.2867C20.9569 21.4603 21.464 20.9533 21.2904 20.4188Z"
        fill="#FFECB3"
      />
      <path
        d="M20.4223 21.2867L18.0745 20.4067C18.0745 20.4067 19.0438 20.3517 19.6987 19.6969C20.3535 19.042 20.4102 18.071 20.4102 18.071L21.2902 20.4188C21.4638 20.9533 20.9568 21.4603 20.4223 21.2867Z"
        fill="#616161"
      />
      <path
        d="M7.42179 3.04393L6.49195 6.3594L3.04757 7.41815L1.10195 5.47425C0.565698 4.938 0.311323 3.86893 1.73273 2.44753L2.59039 1.58987C3.81929 0.360966 4.94164 0.56206 5.47789 1.09831L7.42179 3.04393Z"
        fill="#EF5350"
      />
      <path
        d="M5.89038 7.67253L7.67272 5.89018L18.0248 16.2422C18.0248 16.2422 18.2362 17.1222 17.6982 17.6602C17.1602 18.1982 16.2424 18.0246 16.2424 18.0246L5.89038 7.67253Z"
        fill="#FFC107"
      />
      <path
        d="M4.59448 8.96845L14.6629 19.0369C16.2889 19.391 16.2184 18.0005 16.2184 18.0005L5.89042 7.67252L4.59448 8.96845Z"
        fill="#FFA000"
      />
      <path
        d="M7.67456 5.88847L18.0025 16.2164C18.0025 16.2164 19.8622 16.2164 19.0114 14.6335L8.9705 4.59253L7.67456 5.88847Z"
        fill="#FDD835"
      />
      <path
        d="M16.2027 18.2257L5.7854 7.80831L6.02774 7.56596L16.5121 18.0503L16.2423 18.0228L16.2027 18.2257Z"
        fill="#D1762C"
      />
      <path
        d="M18.0661 16.5258L6.90112 5.36081L7.14519 5.11847L18.226 16.1993L18.0249 16.2405L18.0661 16.5258Z"
        fill="#F19534"
      />
      <path
        d="M8.97042 4.59253C8.97042 4.59253 8.03026 5.983 7.25167 6.77019C5.76151 8.27237 4.59448 8.96847 4.59448 8.96847L4.89526 9.26925C5.32323 9.10253 6.41808 8.60237 7.5112 7.51097C8.6112 6.41097 9.13026 5.33675 9.30386 4.92597L8.97042 4.59253Z"
        fill="#4E342E"
        opacity="0.2"
      />
      <path
        d="M4.03751 8.92034C4.13376 9.01659 4.26954 9.05956 4.40361 9.03722C4.40361 9.03722 5.81126 8.60753 7.21033 7.20847C8.60939 5.80941 9.07173 4.44644 9.07173 4.44644C9.09408 4.31237 9.05111 4.17487 8.95486 4.07862L7.48017 2.60394C7.41829 2.54206 7.33236 2.50941 7.24642 2.51972C7.2172 2.52316 7.18798 2.52659 7.15704 2.53175C7.04017 2.54894 6.94736 2.63487 6.9147 2.74831C6.9147 2.74831 6.24095 4.05456 5.13064 5.16316C4.02033 6.27175 2.66595 6.918 2.66595 6.918C2.55251 6.94894 2.46486 7.04003 2.44767 7.15691C2.44767 7.15862 2.44767 7.15862 2.44767 7.16034C2.43392 7.25316 2.46486 7.34597 2.53017 7.41128L4.03751 8.92034Z"
        fill="#94D1E0"
      />
      <path
        d="M3.12727 3.12643C4.1361 2.11761 4.71178 1.05766 4.41309 0.758974C4.1144 0.460287 3.05446 1.03597 2.04563 2.04479C1.03681 3.05362 0.461128 4.11356 0.759815 4.41225C1.0585 4.71094 2.11845 4.13526 3.12727 3.12643Z"
        fill="#FF8383"
      />
      <path
        d="M7.15199 3.73659C6.58652 4.8194 5.65668 5.708 4.54981 6.2219C4.47762 6.25456 4.37621 6.27862 4.33324 6.21331C4.30059 6.16175 4.32981 6.09643 4.36246 6.04487C4.50684 5.82143 4.70621 5.64096 4.89871 5.45706C5.40059 4.97581 5.86121 4.45331 6.27543 3.89643C6.48684 3.61284 6.68449 3.32065 6.87012 3.01987C6.97324 2.85487 7.15715 2.50596 7.39262 2.75175C7.59715 2.96315 7.26027 3.52862 7.15199 3.73659Z"
        fill="#B9E4EA"
      />
      <path
        d="M6.51089 5.75269C6.4662 5.79909 6.4198 5.8455 6.39745 5.90565C6.37511 5.96581 6.3837 6.04315 6.43527 6.08097C6.47823 6.11362 6.53667 6.11019 6.58995 6.10159C6.8873 6.05519 7.15027 5.88675 7.3823 5.69769C7.88933 5.2869 8.31902 4.71628 8.36027 4.06487C8.36542 3.98753 8.3637 3.90675 8.32933 3.838C8.11105 3.40659 7.6487 4.37081 7.55761 4.50659C7.25339 4.95862 6.89073 5.36425 6.51089 5.75269Z"
        fill="#B9E4EA"
      />
    </g>
    <defs>
      <clipPath id="clip0_262_36127">
        <rect
          fill="white"
          height="22"
          width="22"
        />
      </clipPath>
    </defs>
  </svg>
);

export default EmEditIcon;
